import React, { Component } from "react";
import "../INFOSECTION/404style.css";

class NotFound extends Component {
   
  render() {
   return (
     <>
       <div id="waterP">
         <h2> PAGE NOT FOUND </h2>
         <h2> PAGE NOT FOUND </h2>
       </div>
     </>
   );
  }
}
export default NotFound;